import { denormalize } from 'normalizr';
import { CALL_API, HTTP_METHODS } from '../middlewares/api.js';
import { surveyAnalysis as surveyAnalysisSchema } from '../lib/schema.js';

const ANALYSE_START = 'changesync/surveyAnalysis/ANALYSE_START';
const ANALYSE_SUCCESS = 'changesync/surveyAnalysis/ANALYSE_SUCCESS';
const ANALYSE_FAILURE = 'changesync/surveyAnalysis/ANALYSE_FAILURE';
const RETRIEVE_ANALYSIS_REQUEST =
  'changesync/surveyAnalysis/RETRIEVE_ANALYSIS_REQUEST';
const RETRIEVE_ANALYSIS_SUCCESS =
  'changesync/surveyAnalysis/RETRIEVE_ANALYSIS_SUCCESS';
const RETRIEVE_ANALYSIS_FAILURE =
  'changesync/surveyAnalysis/RETRIEVE_ANALYSIS_FAILURE';
const CREATE_ANALYSIS_REQUEST =
  'changesync/surveyAnalysis/CREATE_ANALYSIS_REQUEST';
const CREATE_ANALYSIS_SUCCESS =
  'changesync/surveyAnalysis/CREATE_ANALYSIS_SUCCESS';
const CREATE_ANALYSIS_FAILURE =
  'changesync/surveyAnalysis/CREATE_ANALYSIS_FAILURE';
const UPDATE_ANALYSIS_REQUEST =
  'changesync/surveyAnalysis/UPDATE_ANALYSIS_REQUEST';
const UPDATE_ANALYSIS_SUCCESS =
  'changesync/surveyAnalysis/UPDATE_ANALYSIS_SUCCESS';
const UPDATE_ANALYSIS_FAILURE =
  'changesync/surveyAnalysis/UPDATE_ANALYSIS_FAILURE';
const DELETE_ANALYSIS_REQUEST =
  'changesync/surveyAnalysis/DELETE_ANALYSIS_REQUEST';
const DELETE_ANALYSIS_SUCCESS =
  'changesync/surveyAnalysis/DELETE_ANALYSIS_SUCCESS';
const DELETE_ANALYSIS_FAILURE =
  'changesync/surveyAnalysis/DELETE_ANALYSIS_FAILURE';

const initialState = {
  analysisId: null,

  retrieveSurveyAnalysis: {
    pending: false,
    success: false,
    error: null,
  },

  generateSurveyAnalysis: {
    pending: false,
    success: false,
    error: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RETRIEVE_ANALYSIS_REQUEST:
      return {
        ...state,
        retrieveSurveyAnalysis: {
          ...state.retrieveSurveyAnalysis,
          pending: true,
          success: false,
          error: null,
        },
      };

    case RETRIEVE_ANALYSIS_SUCCESS:
      return {
        ...state,
        analysisId: action.payload.result,
        retrieveSurveyAnalysis: {
          ...state.retrieveSurveyAnalysis,
          pending: false,
          success: true,
        },
      };
    case RETRIEVE_ANALYSIS_FAILURE:
      return {
        ...state,
        retrieveSurveyAnalysis: {
          ...state.retrieveSurveyAnalysis,
          pending: false,
          error: action.error,
        },
      };

    case ANALYSE_START:
      return {
        ...state,
        generateSurveyAnalysis: {
          ...state.generateSurveyAnalysis,
          error: null,
        },
      };

    case ANALYSE_FAILURE:
      return {
        ...state,
        generateSurveyAnalysis: {
          ...state.generateSurveyAnalysis,
          pending: false,
          error: action.error.error,
        },
      };

    default:
      return state;
  }
};

export const analyseSurvey = (id, query) => (dispatch) => {
  return dispatch({
    [CALL_API]: {
      types: [ANALYSE_START, ANALYSE_SUCCESS, ANALYSE_FAILURE],
      endpoint: `surveys/${id}/ai_analysis`,
      method: HTTP_METHODS.GET,
      query,
    },
  });
};

export const retrieveSurveyAnalysis = (id) => (dispatch) => {
  return dispatch({
    [CALL_API]: {
      types: [
        RETRIEVE_ANALYSIS_REQUEST,
        RETRIEVE_ANALYSIS_SUCCESS,
        RETRIEVE_ANALYSIS_FAILURE,
      ],
      endpoint: `surveys/${id}/analytics`,
      method: HTTP_METHODS.GET,
      schema: surveyAnalysisSchema,
    },
  });
};

export const createSurveyAnalysis = (id, analytic) => (dispatch) => {
  return dispatch({
    [CALL_API]: {
      types: [
        CREATE_ANALYSIS_REQUEST,
        CREATE_ANALYSIS_SUCCESS,
        CREATE_ANALYSIS_FAILURE,
      ],
      endpoint: `surveys/${id}/analytics`,
      method: HTTP_METHODS.POST,
      body: { analytic },
      disabledDecamelizeKeys: true,
    },
  });
};

export const updateSurveyAnalysis = (id, analytic) => (dispatch) => {
  return dispatch({
    [CALL_API]: {
      types: [
        UPDATE_ANALYSIS_REQUEST,
        UPDATE_ANALYSIS_SUCCESS,
        UPDATE_ANALYSIS_FAILURE,
      ],
      endpoint: `surveys/${id}/analytics`,
      method: HTTP_METHODS.PUT,
      body: { analytic },
      disabledDecamelizeKeys: true,
    },
  });
};

export const deleteSurveyAnalysis = (id) => ({
  [CALL_API]: {
    types: [
      DELETE_ANALYSIS_REQUEST,
      DELETE_ANALYSIS_SUCCESS,
      DELETE_ANALYSIS_FAILURE,
    ],
    endpoint: `surveys/${id}/analytics`,
    method: HTTP_METHODS.DELETE,
  },
});

export const selectRetrieveAnalysisState = (state) =>
  state.surveyAnalysis.retrieveSurveyAnalysis;
export const selectGenerateSurveyAnalysisState = (state) =>
  state.surveyAnalysis.generateSurveyAnalysis;

export const selectSurveyAnalysis = (state) =>
  denormalize(
    state.surveyAnalysis.analysisId,
    surveyAnalysisSchema,
    state.entities
  );
